
/**
 * Consolidated browser polyfills for Node.js compatibility
 * This must be imported before any other code that requires Node.js features
 */

// Define base Stream class with proper inheritance
function defineStreamBase() {
  if (typeof (window as any).Stream !== 'undefined') {
    return;
  }

  class Stream {
    constructor() {
      // Initialize any needed properties
    }

    pipe(dest: any) { return dest; }
    on() { return this; }
    once() { return this; }
    emit() { return true; }
    write() { return true; }
    end() {}
    destroy() {}
    resume() { return this; }
    pause() { return this; }
    isPaused() { return false; }
  }

  (window as any).Stream = Stream;
}

// Create derived stream classes with proper inheritance
function defineStreamClasses() {
  const streamClasses = ['Readable', 'Writable', 'Duplex', 'Transform', 'PassThrough'];
  
  streamClasses.forEach(className => {
    if (typeof (window as any)[className] !== 'undefined') {
      return;
    }

    // Create class dynamically with proper inheritance
    const StreamClass = class extends (window as any).Stream {
      constructor() {
        super();
      }
    };

    // Set constructor name
    Object.defineProperty(StreamClass, 'name', { value: className });
    
    // Ensure proper prototype chain
    (window as any)[className] = StreamClass;
    
    // Freeze prototype to prevent modifications
    Object.freeze(StreamClass.prototype);
  });
}

// Define Buffer with complete API
function defineBuffer() {
  if (typeof (window as any).Buffer !== 'undefined') {
    return;
  }

  const BufferMethods = {
    from(data: any, encoding?: string) {
      if (typeof data === 'string') {
        const encoder = new TextEncoder();
        return encoder.encode(data);
      }
      return new Uint8Array(data);
    },
    alloc(size: number) {
      return new Uint8Array(size);
    },
    allocUnsafe(size: number) {
      return new Uint8Array(size);
    },
    isBuffer(obj: any) {
      return obj instanceof Uint8Array;
    }
  };

  // Create Buffer constructor
  const Buffer = function Buffer() {} as any;
  
  // Add static methods
  Object.assign(Buffer, BufferMethods);
  
  // Add prototype methods
  Buffer.prototype = {
    toString(encoding?: string) { return ''; },
    slice(start: number, end: number) { return new Uint8Array(0); }
  };

  (window as any).Buffer = Buffer;
}

// Define process with required properties
function defineProcess() {
  if (typeof (window as any).process !== 'undefined') {
    return;
  }

  (window as any).process = {
    env: {},
    version: '0.0.0',
    platform: 'browser',
    nextTick: (cb: Function) => setTimeout(cb, 0),
    browser: true,
    title: 'browser',
    argv: [],
    cwd: () => '/'
  };
}

// Initialize all polyfills in the correct order
export function initializeBrowserPolyfills() {
  if (typeof window === 'undefined') {
    return;
  }

  console.log('Initializing browser polyfills...');

  try {
    // Initialize in specific order to ensure proper inheritance
    defineProcess();
    defineStreamBase();
    defineStreamClasses();
    defineBuffer();

    console.log('Browser polyfills initialized successfully');
  } catch (error) {
    console.error('Error initializing browser polyfills:', error);
    // Don't throw, but log the error to help with debugging
  }
}

// Auto-initialize when imported
initializeBrowserPolyfills();
